const StatusBadge = ({ status = "Inactive" }) => {
  const safeStatus = typeof status === "string" ? status : "Inactive";

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "activated":
        return "bg-emerald-50 text-emerald-700 border-emerald-200";
      case "pending":
        return "bg-sky-50 text-sky-700 border-sky-200";
      case "revoked":
        return "bg-red-50 text-red-700 border-red-200";
      case "expired":
        return "bg-yellow-50 text-yellow-800 border-yellow-300";
      default:
        return "bg-slate-50 text-slate-600 border-slate-200";
    }
  };

  return (
    <span
      className={`inline-flex px-2.5 py-1 text-xs font-medium rounded border capitalize ${getStatusColor(
        safeStatus
      )}`}
    >
      {safeStatus}
    </span>
  );
};

export default StatusBadge;
